import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getAssetSystems = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-system`);
    return response.data;
  } catch (error) {
    console.error('Error fetching asset systems:', error.response?.data || error);
    throw error;
  }
};

export const getAssetSystemById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-system/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching asset system:', error.response?.data || error);
    throw error;
  }
};

export const createAssetSystem = async (payload) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/asset-system`, payload);
    return response.data;
  } catch (error) {
    console.error('Error creating asset system:', error.response?.data || error);
    throw error;
  }
};

export const updateAssetSystem = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/asset-system/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating asset system:', error.response?.data || error);
    throw error;
  }
};

export const deleteAssetSystem = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/asset-system/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting asset system:', error.response?.data || error);
    throw error;
  }
};
